import * as React from "react";
import { SVGProps } from "react";
export const PinFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 10.042C10.472 10.042 10.8747 9.87533 11.208 9.54199C11.5413 9.20866 11.708 8.80566 11.708 8.33299C11.708 7.86099 11.5413 7.45833 11.208 7.12499C10.8747 6.79166 10.472 6.62499 10 6.62499C9.52801 6.62499 9.12534 6.79166 8.79201 7.12499C8.45867 7.45833 8.29201 7.86099 8.29201 8.33299C8.29201 8.80566 8.45867 9.20866 8.79201 9.54199C9.12534 9.87533 9.52801 10.042 10 10.042ZM10 17.979C9.87467 17.979 9.75667 17.9583 9.64601 17.917C9.53467 17.875 9.43034 17.8193 9.33301 17.75C7.30567 15.9447 5.79867 14.285 4.81201 12.771C3.82601 11.257 3.33301 9.83333 3.33301 8.49999C3.33301 6.40266 3.99967 4.73933 5.33301 3.50999C6.66634 2.28133 8.22201 1.66699 10 1.66699C11.778 1.66699 13.3337 2.28133 14.667 3.50999C16.0003 4.73933 16.667 6.40266 16.667 8.49999C16.667 9.83333 16.1737 11.257 15.187 12.771C14.201 14.285 12.6943 15.9447 10.667 17.75C10.5837 17.8193 10.483 17.875 10.365 17.917C10.247 17.9583 10.1253 17.979 10 17.979Z"
            fill="currentColor"
        />
    </svg>
);
PinFillIcon.displayName = "PinFillIcon";
